var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiAdviserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.9996,
    cy: 24.4996,
    r: 22.4,
    fill: "#000F30"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4377_1844)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.195 23.4383H20.3917C19.7696 23.4383 19.2654 22.934 19.2654 22.312V19.7497C19.2654 19.1277 19.7696 18.6235 20.3917 18.6235H29.4605V21.0309H31.7259C31.7259 19.7803 31.2193 18.647 30.3988 17.8271C29.5789 17.0066 28.4467 16.5 27.195 16.5H19.2266C19.0711 16.5 18.945 16.6261 18.945 16.7816V18.1634C18.945 18.3189 18.8189 18.445 18.6634 18.445H17.2816C17.1261 18.445 17 18.5711 17 18.7266V23.3352C17 23.4907 17.1261 23.6167 17.2816 23.6167H18.6634C18.8189 23.6167 18.945 23.7428 18.945 23.8983V25.2802C18.945 25.4357 19.0711 25.5617 19.2266 25.5617H29.4605V29.2503C29.4605 29.8723 28.9563 30.3765 28.3342 30.3765H19.2654V27.9691H17C17 29.2197 17.5066 30.353 18.3271 31.1729C19.147 31.9928 20.2792 32.5 21.5309 32.5H29.4988C29.6543 32.5 29.7803 32.3739 29.7803 32.2184V30.8366C29.7803 30.6811 29.9064 30.555 30.0619 30.555H31.4438C31.5993 30.555 31.7253 30.4289 31.7253 30.2734V27.9697C31.7253 26.7192 31.2188 25.5859 30.3982 24.766C29.5783 23.946 28.4462 23.4389 27.1945 23.4389L27.195 23.4383Z",
    fill: "#F8009E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4377_1844"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.7259,
    height: 16,
    fill: "white",
    transform: "translate(17 16.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiAdviserIcon);
export default __webpack_public_path__ + "static/media/AiAdviserIcon.fcf4793c2717e3f448d7fec317179b41.svg";
export { ForwardRef as ReactComponent };